import { render, staticRenderFns } from "./candidateUpdates.vue?vue&type=template&id=57405b7c&"
import script from "./candidateUpdates.vue?vue&type=script&lang=js&"
export * from "./candidateUpdates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports